export default __webpack_public_path__ + "static/media/group-634@3x.6fb618c7.png";